export const NoInternetConnection =
  "Hizmete Ulaşamıyoruz, İnternet bağlantınızın olduğundan emin olun";
export const NotWaybillPhoto = "Bu irsaliyenin fotoğrafı eklenmemiş.";
export const FileDeleteInfo = "Bu dosya silinecek.İşlem geri alınamaz";
export const DeleteOk = "Silme işlemi tamamlandı.";
export const UpdateOk = "Güncelleme Tamamlandı";
export   const ArticelDeleteInfo =
  "Bu artikel/sipariş silinecek. İşlem geri alınamaz!   Notlar,ürünler,irsaliyeler ve sipariş dosyaları da silinecek";


// WEBPACK FOOTER //
// ./src/components/Tools/InfoWords.js